import React, { createContext, useContext } from 'react';
import type { ComponentType, ReactNode } from 'react';

export interface ProductCardBadgeProps {
  badges?: any[];
}

interface ProductCardBadgeProviderProps {
  component: ComponentType<ProductCardBadgeProps>;
  children: ReactNode;
}

const ProductCardBadgeContext = createContext<ComponentType<ProductCardBadgeProps> | null>(null);

export const ProductCardBadgeProvider = ({
  component,
  children
}: ProductCardBadgeProviderProps) => (
  <ProductCardBadgeContext.Provider value={component}>{children}</ProductCardBadgeContext.Provider>
);

export const useProductCardBadge = () => useContext(ProductCardBadgeContext);
